import {Injectable} from '@angular/core';
import {SwUpdate} from "@angular/service-worker";
import {AuxService} from "../common/services/aux.service";
import {ModalService} from "../centrui/src/app/services/modal.service";
import {LogService} from "../centrui/src/app/services/log.service";
import {environment} from "../../environments/environment";
import {LogEvent} from "../centrui/src/app/constants/LogEvent";
import {NewVersionAvailableComponent} from "../components/modals/new-version-available/new-version-available.component";
import {NgxSmartModalComponent} from "../centrui/src/app/impl/NgxSmartModalComponent";

@Injectable({
  providedIn: 'root'
})
export class PromptUpdateService {

  constructor(
    private swUpdate: SwUpdate,
    private auxService: AuxService,
    private modalService: ModalService,
    private logService: LogService
  ) {
    this.swUpdate.checkForUpdate().then(result => {
      if (environment.production) {
        this.logService.log(LogEvent.ACTION, null, 'SwUpdate triggered');
        // this.auxService.version().subscribe(response => {
        //   if (response.version != environment.version) {
        //     this.launchNewUpdateModal(response.version, swUpdate);
        //   }
        // }, () => {
        //   console.warn('No version file detected.');
        // });
      }
    }, (error) => {
      console.log(error);
    })
  }

  launchNewUpdateModal(version: string, updates: SwUpdate) {
    this.modalService.open(NewVersionAvailableComponent, {version, preventReload: true}).subscribe((modalResponse: NgxSmartModalComponent) => {
      if (modalResponse.hasData()) {
        this.clearCacheStorage().then(() => {
          updates.activateUpdate().then(() => document.location.reload());
        });
      } else {
        setTimeout(() => this.launchNewUpdateModal(version, updates), 60000);
      }
    });
  }

  clearCacheStorage(): Promise<Promise<boolean>[][]> {
    return caches.keys().then(cacheKeys =>
      Promise.all(
        cacheKeys.map((cacheKey: string) => {
          const ngswRegex = /^(ngsw).*/;
          if (ngswRegex.test(cacheKey)) {
            return caches
              .open(cacheKey)
              .then(cache => cache.keys().then(requests => requests.map(req => cache.delete(req))));
          } else {
            return [];
          }
        })
      )
    );
  }
}
